import { idString } from "../db_utils";
import * as FC from "@fluentui/react-components";
import { TableDef } from "../table_def";
import { useSimpleGrid } from "../components/simple_grid";
import { apiClient } from "./api";

export const ManuLeafDef = new TableDef("manu_leaf", {
    name: {
        label: "厂商名称",
    },
});

export const listManuLeaf = async (apiClient, filter) => {
    try {
        const items = await apiClient.getManuLeaves();
        
        // Apply client-side filtering if needed
        if (filter && filter.trim()) {
            const filterLower = filter.toLowerCase();
            return items.filter(item => 
                item.name?.toLowerCase().includes(filterLower)
            );
        }
        
        return items;
    } catch (error) {
        console.error("Failed to load manu leaves:", error);
        if (error.message && error.message.includes('404')) {
            console.warn("ManuLeaf API not implemented. Using empty list.");
        }
        return [];
    }
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const ManuLeafDropdown = (props) => {
    const { items } = useSimpleGrid({ listItems: listManuLeaf });
    return (
        <FC.Dropdown {...props}>
            {items.map((item) => (
                <FC.Option key={idString(item.id)} value={item.id}>
                    {item.name}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};
